module.exports = __webpack_public_path__ + "dash_20_app_assets/img/gc.07377d14.png";